import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { AuthService } from "../authentication/services/auth.service";
import { LogService } from "../../shared/service/logging/log.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  auth = inject(AuthService);
  logger = inject(LogService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const idToken = this.auth.idToken();
    if (idToken) {
      const modifiedRequest = request.clone({
        headers: request.headers.set("Authorization", `Bearer ${idToken}`),
      });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}
